var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root", class: { disabled: _vm.disabled } }, [
    _c("div", { staticClass: "text" }, [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm.description
        ? _c("div", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.description)),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "switch" },
      [
        _c("w-switch", {
          attrs: { value: _vm.value, disabled: _vm.disabled },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event)
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }